import { render, staticRenderFns } from "./CartPageSharing.vue?vue&type=template&id=3a89a8c5&scoped=true"
import script from "./CartPageSharing.vue?vue&type=script&lang=ts"
export * from "./CartPageSharing.vue?vue&type=script&lang=ts"
import style0 from "./CartPageSharing.vue?vue&type=style&index=0&id=3a89a8c5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a89a8c5",
  null
  
)

export default component.exports